import { useCallback } from 'react';

import { VisitPatient } from '@dreryk/egabinet-visit-frontend-api';
import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { createTranslatedText, TranslatableText } from '@dreryk/react-common';
import { LinkVariant, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { patientPaths } from '~libs.desktop.shared.paths';

import { StyledVisitHeaderPatientNameLink } from './VisitHeaderPatientNameLink.styled';

type VisitHeaderPatientNameLinkProps = {
   readonly patient: VisitPatient | PatientSimple;
   readonly backActionLabel: TranslatableText;
};

export const VisitHeaderPatientNameLink = (props: VisitHeaderPatientNameLinkProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(false);

   const goToPatient = useCallback(
      () =>
         push(patientPaths.getDataPath(props.patient.id), {
            label: props.backActionLabel,
         }),
      [push, props.patient.id, props.backActionLabel]
   );

   return (
      <StyledVisitHeaderPatientNameLink
         testId={'patientName'}
         label={createTranslatedText(`${props.patient.firstName} ${props.patient.lastName}`)}
         onClick={goToPatient}
         variant={LinkVariant.PRIMARY}
      />
   );
};
